import type { ColorTokens } from '@ovComponents/legacyColor';
import type { PipelineStageColorKey } from './tradeFlowPipeline.types';

export function stageDotColor(
  colorTokens: ColorTokens,
  colorKey: PipelineStageColorKey,
): string | undefined {
  switch (colorKey) {
    case 'supportOne':
      return (
        colorTokens.supportOneNew ??
        colorTokens.supportOneVariant ??
        colorTokens.outline
      );
    case 'supportTwo':
      return colorTokens.supportTwo ?? colorTokens.outline;
    case 'supportThree':
      return colorTokens.supportThree ?? colorTokens.outline;
    case 'supportFour':
      return (
        colorTokens.supportFour ??
        colorTokens.supportThree ??
        colorTokens.outline
      );
    case 'positive':
      return colorTokens.positive ?? colorTokens.outline;
    case 'warning':
      return colorTokens.warning ?? colorTokens.outline;
    case 'negative':
      return colorTokens.negative ?? colorTokens.outline;
    default: {
      const _exhaustive: never = colorKey;
      return _exhaustive ?? colorTokens.outline;
    }
  }
}
